import * as types from '../actions/actionTypes';

const defaultState = {
  data: {},
  error: null,
  loading: false,
  loadingSaveDraft: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.GET_BOUNTY_MENTOR_EVALUATION:
    case types.SUBMIT_EVALUATION:
      return {
        ...state,
        loading: !action?.payload?.isDraft,
        loadingSaveDraft: action?.payload?.isDraft,
      };
    case types.GET_BOUNTY_MENTOR_EVALUATION_SUCCESS:
    case types.SUBMIT_EVALUATION_SUCCESS:
      return { ...state, loading: false, loadingSaveDraft: false, data: action.payload };
    case types.GET_BOUNTY_MENTOR_EVALUATION_FAILED:
    case types.SUBMIT_EVALUATION_FAILED:
      return { ...state, loading: false, loadingSaveDraft: false, error: action.error };
    default:
      return state;
  }
};
